import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { CompanyIndexRoute } from 'src/routes/company/CompanyIndex'
import { CompanyDetailsRoute } from 'src/routes/company/CompanyDetails'
import { CompanyCreateRoute } from 'src/routes/company/CompanyCreate'

import { CompanyBranchIndexRoute } from 'src/routes/companyBranch/CompanyBranchIndex'
import { CompanyBranchDetailsRoute } from 'src/routes/companyBranch/CompanyBranchDetails'

import { DepartmentIndexRoute } from 'src/routes/department/DepartmentIndex'
import { DepartmentDetailsRoute } from 'src/routes/department/DepartmentDetails'

import { UserIndexRoute } from 'src/routes/user/UserIndex'
import { UserDetailsRoute } from 'src/routes/user/UserDetails'

import { AcademyIndexRoute } from 'src/routes/academy/AcademyIndex'
import { AcademyDetailsRoute } from 'src/routes/academy/AcademyDetails'
import { AcademyCreateRoute } from 'src/routes/academy/AcademyCreate'

import { TrainingIndexRoute } from 'src/routes/training/TrainingIndex'
import { TrainingUpdateRoute } from 'src/routes/training/TrainingUpdate'
import { TrainingCreateRoute } from 'src/routes/training/TrainingCreate'

import { WorkflowIndexRoute } from 'src/routes/workflow/WorkflowIndex'
import { WorkflowUpdateRoute } from 'src/routes/workflow/WorkflowUpdate'
import { WorkflowCreateRoute } from 'src/routes/workflow/WorkflowCreate'
import { WorkflowDetailsRoute } from 'src/routes/workflow/WorkflowDetails'

import { TrainerIndexRoute } from 'src/routes/trainer/TrainerIndex'
import { TrainerCreateRoute } from 'src/routes/trainer/TrainerCreate'
import { TrainingDetailsRoute } from 'src/routes/training/TrainingDetails'

import { EventPlanningCalendarRoute } from 'src/routes/event/EventPlanningCalendar'
import { EventPlanningListRoute } from 'src/routes/event/EventPlanningList'

import { EventParticipationCalendarRoute } from 'src/routes/event/EventParticipationCalendar'
import { EventParticipantListRoute } from 'src/routes/event/EventParticipantList'
import { EventParticipationDashboardRoute } from 'src/routes/event/EventParticipationDashboard'

import { ApiKeyIndexRoute } from 'src/routes/apikey/ApiKeyIndex'
import { ApiKeyDetailsRoute } from 'src/routes/apikey/ApiKeyDetails'
import { ApiKeyCreateRoute } from 'src/routes/apikey/ApiKeyCreate'

import { UserWorkflowAssignIndexRoute } from 'src/routes/userWorkflowAssign/UserWorkflowAssignIndex'
import { PermissionsIndexRoute } from 'src/routes/permissions/PermissionsIndex'
import { PermissionsDetailsRoute } from 'src/routes/permissions/PermissionsDetails'
import { PermissionsCreateRoute } from 'src/routes/permissions/PermissionsCreate'
import { Statistic } from 'src/routes/statistic/Statistic'
import { StatisticIndex } from 'src/routes/statistic/StatisticIndex'

import { CertificationTopicsIndexRoute } from 'src/routes/certificationTopics/CertificationTopicsIndex'
import { CertificationTopicUpdateRoute } from 'src/routes/certificationTopics/CertificationTopicsUpdate'
import { CertificateConfigurationIndexRoute } from 'src/routes/certificateConfigurations/CertificateConfigurationsIndex'
import { CertificateConfigurationCreateRoute } from 'src/routes/certificateConfigurations/CertificateConfigurationCreate'
import { CertificationCertificateConfigurationUpdateRoute } from 'src/routes/certificateConfigurations/CertificateConfigurationUpdate'
import { CertificateIndexRoute } from 'src/routes/certificates/CertificateIndex'
import { CertificateDetailsRoute } from 'src/routes/certificates/CertificateDetails'
import { CertificateHookIndex } from 'src/routes/certificateHooks/CertificateHookIndex'
import { CertificateHookCreateRoute } from 'src/routes/certificateHooks/CertificateHookCreate'
import { CertificateHookUpdateRoute } from 'src/routes/certificateHooks/CertificateHookUpdate'
import { SearchDashboard } from 'src/routes/statistic/SearchDashboard'
import { QuestionPoolCreateRoute } from 'src/routes/feedback/FeedbackQuestionPoolCreate'
import { QuestionPoolIndexRoute } from 'src/routes/feedback/FeedbackQuestionPoolIndex'
import { QuestionPoolDetailsRoute } from 'src/routes/feedback/FeedbackQuestionPoolDetails'
import { MarahFeedbacksRoute } from 'src/routes/statistic/MarahFeedback'
import { FeedbackIndexRoute } from 'src/routes/feedback/FeedbackIndex'
import { PermissionDeniedRoute } from 'src/routes/permissions/PermissionDenied'
import { PlaybackDetailsRoute } from 'src/routes/playbackEntry/PlaybackDetails'
import { TrainingVideoCreateFormRoute } from 'src/routes/TrainingVideos/TrainingVideosCreate'
import { TrainingVideosDetailsRoute } from 'src/routes/TrainingVideos/TrainingVideosDetails'
import { TrainingVideosIndexRoute } from 'src/routes/TrainingVideos/TrainingVideosIndex'
import { TrainingVideoUpdateFormRoute } from 'src/routes/TrainingVideos/TrainingVideosUpdate'

export function Router() {
    return (
        <Routes>
            <Route path="/" element={<Outlet />}>
                <Route index element={<EventParticipationDashboardRoute />} />
                <Route path="permission-denied" element={<PermissionDeniedRoute />} />

                <Route path="companies" element={<Outlet />}>
                    <Route index element={<CompanyIndexRoute />} />
                    <Route path=":_id" element={<CompanyDetailsRoute />} />
                    <Route path="new" element={<CompanyCreateRoute />} />
                </Route>

                <Route path="companyBranches" element={<Outlet />}>
                    <Route index element={<CompanyBranchIndexRoute />} />
                    <Route path=":_id" element={<CompanyBranchDetailsRoute />} />
                </Route>

                <Route path="departments" element={<Outlet />}>
                    <Route index element={<DepartmentIndexRoute />} />
                    <Route path=":_id" element={<DepartmentDetailsRoute />} />
                </Route>

                <Route path="users" element={<Outlet />}>
                    <Route index element={<UserIndexRoute />} />
                    <Route path=":_id" element={<UserDetailsRoute />} />
                </Route>

                <Route path="academies" element={<Outlet />}>
                    <Route index element={<AcademyIndexRoute />} />
                    <Route path="new" element={<AcademyCreateRoute />} />
                    <Route path=":_id" element={<AcademyDetailsRoute />} />
                </Route>

                <Route path="trainings" element={<Outlet />}>
                    <Route index element={<TrainingIndexRoute />} />
                    <Route path=":_id/update" element={<TrainingUpdateRoute />} />
                    <Route path="new" element={<TrainingCreateRoute />} />
                    <Route path=":_id" element={<TrainingDetailsRoute />} />
                </Route>

                <Route path="training-videos" element={<Outlet />}>
                    <Route index element={<TrainingVideosIndexRoute />} />
                    <Route path=":_id/update" element={<TrainingVideoUpdateFormRoute />} />
                    <Route path="new" element={<TrainingVideoCreateFormRoute />} />
                    <Route path=":_id" element={<TrainingVideosDetailsRoute />} />
                </Route>

                <Route path="trainers" element={<Outlet />}>
                    <Route index element={<TrainerIndexRoute />} />
                    <Route path="new" element={<TrainerCreateRoute />} />
                </Route>

                <Route path="workflows" element={<Outlet />}>
                    <Route index element={<WorkflowIndexRoute />} />
                    <Route path=":_id/update" element={<WorkflowUpdateRoute />} />
                    <Route path=":_id" element={<WorkflowDetailsRoute />} />
                    <Route path="new" element={<WorkflowCreateRoute />} />
                </Route>

                <Route path="events" element={<Outlet />}>
                    <Route index element={<Navigate to="calendar/plan" />} />
                    <Route path="dashboard" element={<EventParticipationDashboardRoute />} />
                    <Route path="list" element={<EventPlanningListRoute />} />
                    <Route path="participants" element={<EventParticipantListRoute />} />
                    <Route path="calendar" element={<Outlet />}>
                        <Route path="plan" element={<EventPlanningCalendarRoute />} />
                        <Route path="participate" element={<EventParticipationCalendarRoute />} />
                    </Route>
                </Route>
                <Route path="playback" element={<Outlet />}>
                    <Route path=":_id" element={<PlaybackDetailsRoute />} />
                </Route>

                <Route path="userWorkflowAssign" element={<Outlet />}>
                    <Route index element={<UserWorkflowAssignIndexRoute />} />
                </Route>

                <Route path="certificate_topics" element={<Outlet />}>
                    <Route index element={<CertificationTopicsIndexRoute />} />
                    <Route path=":_id/update" element={<CertificationTopicUpdateRoute />} />
                </Route>

                <Route path="certificates" element={<Outlet />}>
                    <Route index element={<CertificateIndexRoute />} />
                    <Route path=":_id" element={<CertificateDetailsRoute />} />
                </Route>

                <Route path="certificate_automation" element={<Outlet />}>
                    <Route index element={<CertificateHookIndex />} />
                    <Route path="new" element={<CertificateHookCreateRoute />} />
                    <Route path=":_id/update" element={<CertificateHookUpdateRoute />} />
                </Route>

                <Route path="certificate_configurations" element={<Outlet />}>
                    <Route index element={<CertificateConfigurationIndexRoute />} />
                    <Route path="new" element={<CertificateConfigurationCreateRoute />} />
                    <Route path=":_id/update" element={<CertificationCertificateConfigurationUpdateRoute />} />
                </Route>
                <Route path="statistic" element={<Outlet />}>
                    <Route path=":type/:_id" element={<Statistic />} />
                    <Route path="search" element={<StatisticIndex />} />
                    <Route path="marah-feedbacks" element={<MarahFeedbacksRoute />} />
                </Route>

                <Route path="search" element={<Outlet />}>
                    <Route path=":type/:_id" element={<SearchDashboard />} />
                </Route>
                <Route path="marah-feedback" element={<Outlet />}>
                    <Route path="question_pools" element={<Outlet />}>
                        <Route index element={<QuestionPoolIndexRoute />} />
                        <Route path="new" element={<QuestionPoolCreateRoute />} />
                        <Route path=":_id/update" element={<QuestionPoolDetailsRoute />} />
                    </Route>
                    <Route path="feedbacks" element={<FeedbackIndexRoute />} />
                </Route>

                <Route path="settings" element={<Outlet />}>
                    <Route path="apikeys" element={<Outlet />}>
                        <Route index element={<ApiKeyIndexRoute />} />
                        <Route path=":_id" element={<ApiKeyDetailsRoute />} />
                        <Route path="new" element={<ApiKeyCreateRoute />} />
                    </Route>

                    <Route path="permissions" element={<Outlet />}>
                        <Route index element={<PermissionsIndexRoute />} />
                        <Route path="new" element={<PermissionsCreateRoute />} />
                        <Route path=":_id" element={<PermissionsDetailsRoute />} />
                    </Route>
                </Route>
            </Route>
        </Routes>
    )
}
